// ========================================
// 3列グリッド専用検索JavaScript（修正版 - お気に入り機能削除）
// ファイル名: search-grid-3col.js
// 配置場所: assets/search-grid-3col.js
// ========================================

// 並び替えボタンの文字列セット
(function () {
  const url = new URL(window.location.href);
  const params = url.searchParams;
  const sortByParam = params.get('sort_by');

  const sortModalLabels = document.querySelectorAll('.-sortmodal-label');

  const labelText = (() => {
    switch (sortByParam) {
      case 'created-descending': return '新着順';
      case 'price-ascending': return '価格が安い順';
      case 'price-descending': return '価格が高い順';
      case 'best-selling': return '人気順';
      default: return '並び替え';
    }
  })();
  
  sortModalLabels.forEach((label) => {
    label.textContent = labelText;
  });
})();

// メイン検索機能
document.addEventListener('DOMContentLoaded', function () {
  // Algoliaが利用可能かチェック
  if (typeof algoliasearch === 'undefined' || typeof instantsearch === 'undefined') {
    console.log('Algolia not available, using native Shopify display');
    return;
  }

  // 基本設定
  const searchClient = algoliasearch('XGVCVXZA9R', 'd009fe9f3b4e6fbf728f3d2c27eda693');
  
  const url = new URL(window.location.href);
  const pathName = url.pathname;
  const params = url.searchParams;

  // ★ 追加: コレクションハンドルを取得
  const collectionData = document.querySelector('#collection-data');
  const collectionHandle = collectionData?.dataset.collectionHandle || '';
  
  // ★ 修正: sort_byだけの場合は検索しない（ネイティブ表示を維持）
  const hasSearchParams = params.has('q') || 
                         params.has('type') || 
                         params.has('price') || 
                         params.has('country');
  
  // sort_byのみでコレクションページの場合はネイティブ表示
  if (!hasSearchParams && params.has('sort_by') && collectionHandle) {
    console.log('Sort only on collection page, using native Shopify display');
    return;
  }
  
  if (!hasSearchParams) {
    console.log('No search parameters, using native Shopify display');
    return;
  }
  

  // インデックス名決定
  const indexName = (() => {
    const sortByParam = params.get('sort_by');
    switch (sortByParam) {
      case 'created-descending': return 'shopify_products_created_at_desc';
      case 'price-ascending': return 'products_price_asc';
      case 'price-descending': return 'products_price_desc';
      case 'best-selling': return 'shopify_products_recently_ordered_count_desc';
      default: return 'shopify_products_created_at_desc';
    }
  })();
  
  const search = instantsearch({
    indexName: indexName,
    searchClient,
  });

  // フィルター設定
  const priceFilter = [];
  const categoryFacetFilters = {};
  let searchTitle = '';

  // パスベースのフィルター設定
  const pathFilterMap = {
    '/collections/red-wine': { type: 'red-wine' },
    '/collections/white-wine': { type: 'white-wine' },
    '/collections/rose-wine': { type: 'rose-wine' },
    '/collections/orange-wine': { type: 'orange-wine' },
    '/collections/sparkling-wine': { type: 'sparkling-wine' },
    '/collections/dealcoholized-wine-juice': { type: 'dealcoholized-wine-juice' },
    '/collections/%E3%82%B7%E3%82%A7%E3%83%AA%E3%83%BC%E9%85%92': { type: 'sherry-wine' },
    '/collections/beer': { type: 'beer' },
    '/collections/0-999': { price: '0-999' },
    '/collections/1000-1999': { price: '1000-1999' },
    '/collections/2000-2999': { price: '2000-2999' },
    '/collections/3000-4999': { price: '3000-4999' },
    '/collections/5000-9999': { price: '5000-9999' },
    '/collections/over10000': { price: 'over10000' },
    '/collections/gifts': { collections: 'gifts' },
    '/collections/new-arrival': { collections: 'New-Arrival' },
    '/collections/spainwinewes': { collections: 'spainwinewes' },
    '/collections/clearance202509': { collections: 'クリアランスセールベルビーニョ' },
    '/collections/daily-use': { collections: 'daily-use' }
  };

  if (pathFilterMap[pathName]) {
    const filter = pathFilterMap[pathName];
    Object.entries(filter).forEach(([key, value]) => {
      params.set(key, value);
    });
    searchTitle = getSearchValue(Object.keys(filter)[0], Object.values(filter)[0], true);
  }

  // パラメータベースのフィルター構築
  params.forEach((value, key) => {
    const searchValue = getSearchValue(key, value);
    if (searchValue === '不明な値') return;

    if (!categoryFacetFilters[key]) {
      categoryFacetFilters[key] = [];
    }

    switch (key) {
      case 'type':
        categoryFacetFilters[key].push(`meta.custom.type:${searchValue}`);
        break;
      case 'area':
        categoryFacetFilters[key].push(`meta.custom.area:${searchValue}`);
        break;
      case 'climate':
        categoryFacetFilters[key].push(`meta.custom.climate:${searchValue}`);
        break;
      case 'english_name':
        categoryFacetFilters[key].push(`meta.custom.english_name:${searchValue}`);
        break;
      case 'excerpt':
        categoryFacetFilters[key].push(`meta.custom.excerpt:${searchValue}`);
        break;
      case 'main_variety':
        categoryFacetFilters[key].push(`meta.custom.main_variety:${searchValue}`);
        break;
      case 'country':
        categoryFacetFilters[key].push(...normalizeMetaobjectFormatArray(`meta.custom.country:${searchValue}`));
        break;
      case 'manufacturer':
        categoryFacetFilters[key].push(`meta.custom.manufacturer:${searchValue}`);
        break;
      case 'scent':
        categoryFacetFilters[key].push(...normalizeMetaobjectFormatArray(`meta.custom.scent:${searchValue}`));
        break;
      case 'slimilarproduct':
        categoryFacetFilters[key].push(`meta.custom.slimilarproduct:${searchValue}`);
        break;
      case 'soil':
        categoryFacetFilters[key].push(`meta.custom.soil:${searchValue}`);
        break;
      case 'taste':
        categoryFacetFilters[key].push(`meta.custom.taste:${searchValue}`);
        break;
      case 'temperature':
        categoryFacetFilters[key].push(`meta.custom.temperature:${searchValue}`);
        break;
      case 'variety':
        categoryFacetFilters[key].push(`meta.custom.variety:${searchValue}`);
        break;
      case 'year':
        categoryFacetFilters[key].push(`meta.custom.year:${searchValue}`);
        break;
      case 'cork':
        categoryFacetFilters[key].push(`meta.spec.cork:${searchValue}`);
        break;
      case 'volume':
        categoryFacetFilters[key].push(`meta.spec.volume:${searchValue}`);
        break;
      case 'acrid':
        categoryFacetFilters[key].push(`meta.tastenotes.acrid:${searchValue}`);
        break;
      case 'body':
        categoryFacetFilters[key].push(`meta.tastenotes.body:${searchValue}`);
        break;
      case 'impression':
        categoryFacetFilters[key].push(`meta.tastenotes.impression:${searchValue}`);
        break;
      case 'sour':
        categoryFacetFilters[key].push(`meta.tastenotes.sour:${searchValue}`);
        break;
      case 'sweet':
        categoryFacetFilters[key].push(`meta.tastenotes.sweet:${searchValue}`);
        break;
      case 'price':
        priceFilter.push(searchValue);
        break;
      case 'collections':
        categoryFacetFilters[key].push(`collections:${searchValue}`);
        break;
      default:
        break;
    }
  });

  const facetFilters = Object.values(categoryFacetFilters);
  const filters = priceFilter.join(' OR ');

  const configureParameters = {
    query: params.get('q') || '',
    hitsPerPage: 12, // 3列×4行
    filters: filters,
    facetFilters: facetFilters,
  };

  console.log('Applied filters:', facetFilters.toString());

  const configure = instantsearch.widgets.configure(configureParameters);

  // 検索結果表示（3列グリッド専用・並び替え前と統一）
  const hits = instantsearch.widgets.hits({
    container: '#hits',
    templates: {
      empty(results, { html }) {
        return html`
          <div class="c-collection-grid-3col">
            <div class="c-collection-grid-3col__empty">
              <p>商品が見つかりませんでした。</p>
            </div>
          </div>
        `;
      },
      item(hit, { html, components }) {
         console.log(hit.title, hit.meta?.custom?.member_discount_percent);
        // セーフガード
        const title = hit.title || '商品名なし';
        const handle = hit.handle || '#';
        const price = hit.price || null;
        const comparePrice = hit.compare_at_price || null;
        const inventory = hit.inventory_quantity ?? 0;
        
        return html`
          <div class="c-collection-grid-3col__item">
            <div class="c-product-box">
              <!-- 商品画像エリア -->
              <div class="c-product-box__image-wrapper">
                <a href="/products/${handle}">
                  ${hit.image ? html`
                    <img 
                      src="${getSizedImageUrl(hit.image, '400x400')}" 
                      alt="${title}"
                      loading="lazy"
                      width="400" 
                      height="400"
                      class="c-product-box__image"
                      onerror="this.style.display='none'"
                    />
                  ` : html`
                    <div class="c-product-box__no-image">
                      <span>画像なし</span>
                    </div>
                  `}
                </a>
                
                <!-- バッジエリア -->
                ${comparePrice && comparePrice > price ? html`
                  <span class="c-product-box__badge --sale">SALE</span>
                ` : ''}
                
                <!-- ワインタイプタグ（商品名上） -->
                ${hit.meta?.custom?.type ? html`
                  <div class="c-product-box__wine-tag">
                    ${html([generateWineTag(hit.meta.custom.type)])}
                  </div>
                ` : ''}
              </div>
              
              <!-- 商品情報エリア -->
              <div class="c-product-box__content">
                <a href="/products/${handle}">
                  <h3 class="c-product-box__title">${title}</h3>
                </a>
                
                <!-- 産地情報 -->
                ${getCountryInfo(hit.meta?.custom?.country) ? html`
                  <div class="c-product-box__country">
                    <img 
                      src="${getCountryInfo(hit.meta?.custom?.country).flag}" 
                      loading="lazy" 
                      class="c-product-box__flag"
                      onerror="this.style.display='none'"
                    />
                    <span>${getCountryInfo(hit.meta?.custom?.country).name}</span>
                  </div>
                ` : ''}
                
                <!-- 地域情報 -->
                ${hit.meta?.custom?.area ? html`
                  <div class="c-product-box__area">
                    地域：${hit.meta.custom.area}
                  </div>
                ` : ''}
                
                <!-- ワイン詳細情報 -->
                ${(hit.meta?.custom?.variety || hit.meta?.custom?.year) ? html`
                  <div class="c-product-box__wine-details">
                    ${hit.meta.custom.variety ? html`
                      <div class="c-product-box__variety">ブドウ品種：${hit.meta.custom.variety}</div>
                    ` : ''}
                    ${hit.meta.custom.year ? html`
                      <div class="c-product-box__year">製造年：${hit.meta.custom.year}年</div>
                    ` : ''}
                  </div>
                ` : ''}
                
                <!-- 商品説明 -->
                ${hit.meta?.custom?.excerpt ? html`
                  <div class="c-product-box__excerpt">
                    ${hit.meta.custom.excerpt}
                  </div>
                ` : html`
                  <div class="c-product-box__excerpt">
                    <!-- 空の説明文エリア（高さ統一のため） -->
                  </div>
                `}
                
                <!-- 価格エリア -->
                  ${price ? html`
                    <div class="c-product-box__price-wrapper">
                      ${hit.meta?.custom?.member_discount_percent ? html`
                        <div class="c-product-box__priceOriginal">
                          ¥${price.toLocaleString()}
                          <span class="c-product-box__priceTax"> (税込) </span>
                        </div>
                        <div class="c-product-box__priceMember">
                          ¥${Math.floor(price - (price * hit.meta.custom.member_discount_percent)).toLocaleString()}
                          <span class="c-product-box__priceTax"> (税込) </span>
                          <img
                            src="https://cdn.shopify.com/s/files/1/0740/5115/8311/files/40_OFF2.webp?v=1785478833"
                            alt="会員クーポン"
                            class="c-product-box__memberPriceLabel"
                            loading="lazy"
                          />
                        </div>
                      ` : html`
                        <span class="c-product-box__price --current">¥${price.toLocaleString()}</span>
                      `}
                      ${comparePrice && comparePrice > price ? html`
                        <span class="c-product-box__price --compare">¥${comparePrice.toLocaleString()}</span>
                      ` : ''}
                    </div>
                  ` : ''}
                
                <!-- アクションエリア -->
                <div class="c-product-box__actions">
                  <!-- カートボタン -->
                  <div class="c-product-box__cart">
                    ${inventory > 0 ? html`
                      <button
                        class="a-button -addCart"
                        type="button"
                        data-micromodal-trigger="modal-cart"
                        data-product-max-quantity="${inventory}"
                        data-product-variant-id="${hit.objectID}"
                      >
                        <span class="a-button__label">カートに入れる</span>
                      </button>
                    ` : html`
                      <button class="a-button -addCart -disabled" disabled>
                        <span class="a-button__label">在庫がありません</span>
                      </button>
                    `}
                  </div>
                </div>
              </div>
            </div>
          </div>
        `;
      },
    },
    cssClasses: {
      root: '', // グリッドコンテナは既にHTMLにある
      list: 'c-collection-grid-3col',
    },
  });

  // ページネーション
  const renderPagination = (renderOptions, isFirstRender) => {
    const { pages, currentRefinement, nbPages, isFirstPage, isLastPage, refine, createURL } = renderOptions;

    const container = document.querySelector('#pagination');
    if (!container) return;

    const prevUrl = new URL(window.location.href);
    prevUrl.searchParams.set('page', currentRefinement);

    const nextUrl = new URL(window.location.href);
    nextUrl.searchParams.set('page', currentRefinement + 2);

    const url = new URL(window.location.href);
    const params = url.searchParams;
    const pageParam = params.get('page');
    const page = pageParam ? parseInt(pageParam, 10) - 1 : 0;

    if (page !== currentRefinement) refine(page);

    container.innerHTML = `
      <div class="c-collection-pagination">
        <div class="m-pagination">
          ${!isFirstPage 
            ? `<a href="${prevUrl}" class="m-pagination__button -prev" aria-label="前のページ"></a>`
            : '<span class="m-pagination__button -prev" aria-disabled="true"></span>'
          }
          <span class="m-pagination__page">
            <span class="-current">${currentRefinement + 1}</span>
            <span>of</span>
            <span>${nbPages}</span>
          </span>
          ${!isLastPage 
            ? `<a href="${nextUrl}" class="m-pagination__button -next" aria-label="次のページ"></a>`
            : '<span class="m-pagination__button -next" aria-disabled="true"></span>'
          }
        </div>
      </div>
    `;
  };

  const customPagination = instantsearch.connectors.connectPagination(renderPagination);

  // 検索統計
  const stats = instantsearch.widgets.stats({
    container: '#stats',
    templates: {
      text(data, { html }) {
        return html`
          <div class="p-itemList__amount">
            ${data.nbHits} items
            <div class="p-itemList__title">
              <span>${searchTitle || (data.query ? `${data.query}の検索結果` : '全商品')}</span>
            </div>
          </div>
        `;
      },
    },
  });

  // ネイティブコンテンツを非表示にしてAlgolia結果を表示
  const nativeContainer = document.querySelector('.c-collection-grid-3col');
  if (nativeContainer) {
    nativeContainer.style.display = 'none';
  }

  // ウィジェット追加・検索開始
  search.addWidgets([
    configure,
    hits,
    customPagination({
      container: document.querySelector('#pagination'),
    }),
    stats,
  ]);

  search.on('render', () => {
    try {
      if (typeof onDOMContentLoaded === 'function') {
        onDOMContentLoaded();
      }
      // お気に入り機能は削除済み
    } catch (error) {
      console.error('Post-render processing error:', error);
    }
  });

  search.start();
});

// ========================================
// UI イベントハンドラー
// ========================================

// 絞り込みモーダル
document.addEventListener('DOMContentLoaded', function () {
  const searchModalButtons = document.querySelectorAll('.-searchModalButton');
  searchModalButtons.forEach((button) => {
    button.addEventListener('click', function (e) {
      e.preventDefault();
      const modal = document.getElementById('modal-search');
      if (modal) {
        modal.classList.toggle('is-open');
      }
    });
  });
});

// スマホ絞り込みメニュー
document.addEventListener('DOMContentLoaded', function () {
  const jsModalSearchBoxTriggers = document.querySelectorAll('.js-modalSearch-box-trigger');
  jsModalSearchBoxTriggers.forEach((jsModalSearchBoxTrigger) => {
    jsModalSearchBoxTrigger.addEventListener('click', function (e) {
      e.preventDefault();
      jsModalSearchBoxTrigger.classList.toggle('is-open');
    });
  });
});

// タグ表示・削除
document.addEventListener('DOMContentLoaded', function () {
  const url = new URL(window.location.href);
  const params = url.searchParams;
  const tagList = document.querySelector('.p-itemList__tagList');
  
  if (!tagList) return;

  const tagItems = [];
  params.forEach((value, key) => {
    const searchValue = getSearchValue(key, value, true);
    if (searchValue !== '不明な値') {
      tagItems.push(searchValue);
    }
  });

  tagItems.forEach((tagItem) => {
    const tag = document.createElement('div');
    tag.classList.add('p-itemList__tagItem');
    tag.innerHTML = `
      <span class="a-tag -withXbutton">
        <span class="a-tag__label">${tagItem}</span>
        <button class="a-tag__closeButton" aria-label="タグを削除"></button>
      </span>
    `;
    tagList.appendChild(tag);
  });
  
  // タグ削除機能
  const tagCloseButtons = document.querySelectorAll('.a-tag__closeButton');
  tagCloseButtons.forEach((button) => {
    button.addEventListener('click', function (e) {
      e.preventDefault();
      const tag = button.closest('.p-itemList__tagItem');
      if (!tag) return;
      
      const tagLabel = tag.querySelector('.a-tag__label')?.textContent;
      tag.remove();
      
      if (tagLabel) {
        const url = new URL(window.location.href);
        const params = url.searchParams;
        params.set('page', 1);

        params.forEach((value, key) => {
          const searchValue = getSearchValue(key, value, true);
          if (searchValue === tagLabel) {
            params.delete(key);
          }
        });
        
        window.location.href = url.toString();
      }
    });
  });
});

// ========================================
// ユーティリティ関数
// ========================================

// 国IDマッピング（実際のデータに基づく）
const countryMapping = {
  "gid://shopify/Metaobject/21910094119": {
    name: "スペイン",
    flag: "//amavino.jp/cdn/shop/files/icon_flag_spain_small.png?v=1700299608"
  },
  "gid://shopify/Metaobject/21916483879": {
    name: "フランス",
    flag: "//amavino.jp/cdn/shop/files/icon_flag_france_small.png?v=1700532323"
  },
  "gid://shopify/Metaobject/21916582183": {
    name: "ドイツ", 
    flag: "//amavino.jp/cdn/shop/files/icon_flag_germany_small.png?v=1700532189"
  },
  "gid://shopify/Metaobject/23366664487": {
    name: "南アフリカ",
    flag: "//amavino.jp/cdn/shop/files/icon_flag_southAfrica_small.png?v=1700640470"
  },
  // 他の国が見つかったら追加
};

// 国情報取得関数
function getCountryInfo(countryData) {
  if (!countryData || !Array.isArray(countryData) || countryData.length === 0) {
    return null;
  }
  const countryId = countryData[0];
  return countryMapping[countryId] || null;
}

// ワインタグ生成（既存色を使用）
function generateWineTag(wineClass) {
  const wineTagMap = {
    '赤ワイン': { css: 'cat01', label: '赤ワイン' },
    '白ワイン': { css: 'cat02', label: '白ワイン' },
    'ロゼワイン': { css: 'cat03', label: 'ロゼワイン' },
    'オレンジワイン': { css: 'cat04', label: 'オレンジワイン' },
    'スパークリングワイン': { css: 'cat05', label: 'スパークリング' },
    'スパークリング': { css: 'cat05', label: 'スパークリング' },
    '脱アルコールワイン・ワインジュース': { css: 'cat06', label: 'ノンアル' },
    'ノンアル / 脱アルワイン': { css: 'cat06', label: 'ノンアル' },
    'ビール・脱アルコールビール': { css: 'cat07', label: 'ビール' },
    'ビール / 脱アルビール': { css: 'cat07', label: 'ビール' },
    'シェリー酒': { css: 'cat08', label: 'シェリー酒' },
  };

  const tagInfo = wineTagMap[wineClass] || { css: 'cat-etc', label: wineClass };
  
  return `<span class="a-itemTag -${tagInfo.css}"><span class="a-itemTag__label">${tagInfo.label}</span></span>`;
}

// 画像ヘルパー関数
function getSizedImageUrl(src, size) {
  if (!src || size === null) return src;
  if (size === 'master') return removeProtocol(src);

  const match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif|webp)(\?v=\d+)?$/i);
  if (match) {
    const prefix = src.split(match[0]);
    const suffix = match[0];
    return removeProtocol(`${prefix[0]}_${size}${suffix}`);
  }
  return src;
}

function removeProtocol(path) {
  return path?.replace(/http(s)?:/, '') || path;
}

// 検索値取得関数（簡略版 - 必要に応じて元のコードから完全版をコピー）
function getSearchValue(key, value, useDisplay = false) {
  const nameMap = {
    'collections': {
      'gifts': { 'display': 'プレゼントにおすすめ', 'search': 'gifts' },
      'daily-use': { 'display': 'デイリーワインに おすすめ', 'search': 'daily-use' },
      'spainwinewes': { 'display': 'スペインワインフェス', 'search': 'spainwinewes' },
      'クリアランスセールベルビーニョ': { 'display': 'クリアランスセールベルビーニョ', 'search': 'クリアランスセールベルビーニョ' },
      'New-Arrival': { 'display': '新商品', 'search': 'New-Arrival' },
    },
    'type': {
      'red-wine': { 'display': '赤ワイン', 'search': '赤ワイン' },
      'white-wine': { 'display': '白ワイン', 'search': '白ワイン' },
      'rose-wine': { 'display': 'ロゼワイン', 'search': 'ロゼワイン' },
      'orange-wine': { 'display': 'オレンジワイン', 'search': 'オレンジワイン' },
      'sparkling-wine': { 'display': 'スパークリングワイン', 'search': 'スパークリングワイン' },
      'dealcoholized-wine-juice': { 'display': '脱アルコールワイン・ワインジュース', 'search': '脱アルコールワイン・ワインジュース' },
      'beer': { 'display': 'ビール・脱アルコールビール', 'search': 'ビール・脱アルコールビール' },
      'sherry-wine': { 'display': 'シェリー酒', 'search': 'シェリー酒' },
    },
    'price': {
      '0-999': { 'display': '~¥999', 'search': 'price <= 999' },
      '1000-1999': { 'display': '¥1,000～¥1,999', 'search': 'price:1000 TO 1999' },
      '2000-2999': { 'display': '¥2,000～¥2,999', 'search': 'price:2000 TO 2999' },
      '3000-4999': { 'display': '¥3,000～¥4,999', 'search': 'price:3000 TO 4999' },
      '5000-9999': { 'display': '¥5,000～¥9,999', 'search': 'price:5000 TO 9999' },
      'over10000': { 'display': '¥10,000～', 'search': 'price >= 10000' },
    },
    // その他のマッピングは必要に応じて元のコードから追加
  };

  if (nameMap[key]?.[value]) {
    return useDisplay ? nameMap[key][value]['display'] : (nameMap[key][value]['search'] || nameMap[key][value]['display']);
  }
  return '不明な値';
}

function normalizeMetaobjectFormatArray(query) {
  const colonIndex = query.indexOf(':');
  const key = query.substring(0, colonIndex);
  const searchValue = query.substring(colonIndex + 1);
  return [`${key}:["${searchValue}"`, `${key}:${searchValue}`, `${key}:${searchValue}"]`];
}